module.exports = __webpack_public_path__ + "resource/img/borrow.5ed8d577.png";